import './toast.css'

import { toast as Toast } from 'react-toastify'

export default Toast
